import React from "react";
import { ChevronUp, ChevronDown } from "lucide-react";

const SectionHeader = ({
  icon: Icon,
  title,
  color,
  section,
  badge,
  toggleSection,
  expandedSections,
}) => {
  const isExpanded = expandedSections?.[section];

  return (
    <div
      onClick={() => {
        toggleSection(section);
      }}
      className="w-full flex items-center justify-between px-4 py-2.5 
      bg-gradient-to-r from-slate-50 to-white 
      dark:from-slate-800/80 dark:to-slate-900 
      border-b border-slate-200 dark:border-slate-700 
      hover:from-slate-100 dark:hover:from-slate-700 
      transition-all cursor-pointer"
    >
      <div className="flex items-center gap-2">
        <div className={`p-1.5 rounded-md ${color}`}>
          {Icon && <Icon className="w-3.5 h-3.5 text-white" />}
        </div>

        <h2 className="text-sm font-semibold text-slate-800 dark:text-white">
          {title}
        </h2>

        {badge && (
          <span
            className="px-1.5 py-0.5 bg-blue-100 dark:bg-blue-900/30 
          text-blue-700 dark:text-blue-400 text-[10px] 
          font-medium rounded-full"
          >
            {badge}
          </span>
        )}
      </div>

      {isExpanded ? (
        <ChevronUp className="w-4 h-4 text-slate-400" />
      ) : (
        <ChevronDown className="w-4 h-4 text-slate-400" />
      )}
    </div>
  );
};

export default SectionHeader;
